/**
 * State Timeline constants — colors keyed by the actual eventName from the API.
 */

import { CHART_PALETTE } from "../../constants/chartPalette";

export const EVENT_COLORS = {
  // Charging & Plug track
  "Charging Started": CHART_PALETTE.amber,
  "EV Plugged In": CHART_PALETTE.green,
  "EV Plugged Out": "#e2e8f0", // Light gray — idle/disconnected state
  "Charging Stopped": CHART_PALETTE.amber,
  "EVSE Not Ready": "#fb923c", // Orange-400
  "EV Not Ready": "#fdba74", // Orange-300

  // Connectivity track
  "Gateway Disconnected": "#f97316", // Orange-500 — active disconnect
  "Gateway Connected": CHART_PALETTE.green, // Cleared state
  "Safe Limit Mode": "#eab308", // Yellow-500
  "Safe Limit Mode Cleared": CHART_PALETTE.green, // Cleared state

  // Faults track
  "Fault Detected": CHART_PALETTE.red,
  "Fault Cleared": CHART_PALETTE.cyan,
  "Ground Missing Fault": CHART_PALETTE.red,
  "Vehicle Fault": "#dc2626", // Red-600
  "CCID Fault": "#b91c1c", // Red-700
  "Contactor Bad Fault": "#991b1b", // Red-800
  "Internal Error": "#f87171", // Red-400
  "Cosmos Communication Fault": "#fb7185", // Rose-400
  "Overcurrent Fault": "#e11d48", // Rose-600
  "Connector Lock Failure": "#be123c", // Rose-700
  "System Off Grid": "#a855f7", // Purple-500
};

/**
 * Timeline track definitions.
 * Each track groups logically related events into a separate horizontal bar.
 * `alwaysShow` tracks are rendered even when they have no events.
 */
export const TIMELINE_TRACKS = [
  {
    id: "charging",
    label: "Charging",
    alwaysShow: true,
    events: [
      "Charging Started",
      "Charging Stopped",
      "EV Plugged In",
      "EV Plugged Out",
      "EVSE Not Ready",
      "EV Not Ready",
    ],
    defaultState: "EV Plugged Out", // idle state when no events
  },
  {
    id: "connectivity",
    label: "Gateway",
    alwaysShow: true,
    events: ["Gateway Disconnected", "Gateway Connected", "Safe Limit Mode", "Safe Limit Mode Cleared"],
    defaultState: "Gateway Connected", // healthy state when no events
  },
  {
    id: "faults",
    label: "Faults",
    alwaysShow: false, // only show if events exist
    events: [
      "Fault Detected",
      "Fault Cleared",
      "Ground Missing Fault",
      "Vehicle Fault",
      "CCID Fault",
      "Contactor Bad Fault",
      "Internal Error",
      "Cosmos Communication Fault",
      "Overcurrent Fault",
      "Connector Lock Failure",
      "System Off Grid",
    ],
    defaultState: "Fault Cleared", // healthy state when no faults
  },
];

export const DEFAULT_SEGMENT_COLOR = CHART_PALETTE.slate;

export const MARGIN = { top: 10, right: 20, bottom: 30, left: 75 };

export const TIMELINE_BAR_HEIGHT = 24;
export const TIMELINE_BAR_RADIUS = 4;
export const TRACK_GAP = 4;
export const TRACK_LABEL_WIDTH = 75;

export const TICK_COUNT = 8;
export const LABEL_CHAR_WIDTH = 7;
export const ABBREV_MIN_WIDTH = 30;
export const X_AXIS_GAP = 6;
export const X_AXIS_EXTRA_HEIGHT = 20;
export const DAY_MS = 86400000;
export const NOW_INDICATOR_THRESHOLD_MS = 60000;
